import { render, staticRenderFns } from "./AccountSearchFee.vue?vue&type=template&id=4a067e9c&scoped=true&"
import script from "./AccountSearchFee.vue?vue&type=script&lang=js&"
export * from "./AccountSearchFee.vue?vue&type=script&lang=js&"
import style0 from "./AccountSearchFee.vue?vue&type=style&index=0&id=4a067e9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a067e9c",
  null
  
)

export default component.exports